export const AppConfigTR={
AppCID:{en:'AppCID',cs:'AppCID',dataType:'number',format:'#0',required:true},
AppCTimeStamp:{en:'AppCTimeStamp',cs:'AppCTimeStamp',dataType:'number',format:'#0'},
AppCWorkdayDBConnectionString:{en:'Workday Connection String',cs:'',dataType:'string',maxLength:4000},
AppCProjectNumberGeneratorNuGeID:{en:'Project Number Generator',cs:'',dataType:'number',format:'#0'},
AppCIsTestEnvironment:{en:'Test Environment',cs:'',dataType:'boolean',required:true},
AppCSMTPHost:{en:'SMTP Host',cs:'',dataType:'string',maxLength:400},
AppCSMTPLogin:{en:'SMTP Login',cs:'',dataType:'string',maxLength:400},
AppCSMTPPassword:{en:'SMTP Password',cs:'',dataType:'string',maxLength:400},
AppCTCCURL:{en:'Site URL',cs:'Site URL',dataType:'string',maxLength:400},
AppCDefaultEmail:{en:'Default TSS Email',cs:'',dataType:'string',maxLength:400},
AppCDBBodyBgColor:{en:'Body Background Color',cs:'',dataType:'string',maxLength:28},
AppcEmailsAfterTenderFilling:{en:'Emails After Tender Submission (;)',cs:'E-maily po vyplnění SPZ (;)',dataType:'string'}
}